import { updateLobType } from "../../../../../actions/Utilities/LobType";
import { useMutation } from "react-query";

const useUpdateLobType = () => {
  return useMutation(updateLobType);
};
export default useUpdateLobType;
